import { jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import s from './Button.module.scss';
export var BtnVariant;
(function (BtnVariant) {
    BtnVariant["light"] = "lightVariant";
})(BtnVariant || (BtnVariant = {}));
export const Button = ({ children, disabled = false, variant = BtnVariant.light, icon = null, onClick, className }) => (_jsxs("button", { disabled: disabled, className: classNames(s.button, className, { [s[variant]]: true }), onClick: onClick, children: [icon, children] }));
